export async function getList({ commit }, payload) {
  const { errResponse, data: responseData } = await this.$adminRepositories.transactions.getList(payload);

  if (!errResponse) {
    return commit('setList', responseData.data);
  }
}

export async function getAmountInRange({ commit }, payload) {
  const { errResponse, data: responseData } = await this.$adminRepositories.transactions.getAmountInRange(payload);

  if (!errResponse) {
    return commit('setAmountList', responseData.data);
  }
}

export async function getAmountMonth({ commit }) {
  const { errResponse, data: responseData } = await this.$adminRepositories.transactions.getAmountMonth();

  if (!errResponse) {
    return commit('setMonthData', responseData.data);
  }
}

export async function setCancelStatus(_, payload) {
  return await this.$adminRepositories.transactions.setCancelStatus(payload);
}